<div>
  <div class="flex flex-wrap gap-3 items-center">
    <div>
      <a routerLink="/" class="flex items-center justify-center bg-white p-1 border border-grey-300 rounded-sm cursor-pointer sm:hidden">
        <i class="pi pi-chevron-left text-grey-600"></i>
      </a>
      <a class="hidden text-muted sm:inline" routerLink="/">{{ 'machineRange.dashboard' | transloco }}</a>
    </div>
    <div class="hidden text-muted sm:block">/</div>
    <p-select 
      class="flex-1 min-w-0 w-full sm:flex-none sm:w-auto"
      [options]="(ranges$ | async) ?? []"
      [ngModel]="selectedRange$.value"
      (ngModelChange)="selectedRange$.next($event)"
      optionLabel="name"
      placeholder="{{ 'machineRange.selectARange' | transloco}}"
      (onChange)="changePage($event)"
    />
  </div>
</div>

<div>
  @if (groups$ | async; as groups) {
    @for (group of groups; track group.name) {
      <div class="border-t border-grey-300 pt-4 mt-4 md:pt-8 md:mt-8">
        <h2 class="text-lg font-bold mb-3">{{ group.name }}</h2>
        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-6 gap-6">
          @for (machine of group.machines; track machine.id) {
            <a class="cursor-pointer block" routerLink="/machine/{{ machine.id }}">
              <img class="block w-full aspect-square object-cover rounded-md" [src]=machine.thumbnail.public_asset_url alt="">
              <h3 [title]="machine.title" class="font-bold w-full mt-3 px-1 break-words">{{ machine.title | truncate:50 }}</h3>
              <p [title]="machine.sub_heading" class="text-muted text-[11px] leading-[9px] sm:text-sm/3 w-full px-1 break-words">{{ machine.sub_heading | truncate:50 }}</p>
            </a>
          }
        </div>
      </div>
    }
  }
</div>
